module.exports = __webpack_public_path__ + "fonts/sourcesansprolight.de0cf4e1.woff2";